// Scrolling mirrors reviews-carousel: a CSS marquee on desktop (paused on hover)
// and a native snap carousel on mobile. This only drives video playback.
class SocialUgc extends HTMLElement {
    constructor() {
        super()
        this.activeCard = null
        this.scrollTicking = false
    }

    connectedCallback() {
        this.track = this.querySelector("[data-track]")
        this.cards = Array.from(this.querySelectorAll("[data-card]"))
        this.realCards = this.cards.filter(
            (card) => !card.hasAttribute("data-clone")
        )

        this.setupVideos()

        if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
            this.cards.forEach((card) => {
                card.addEventListener("pointerenter", () =>
                    this.setActive(card)
                )
                // Safari can fire a stray pointerleave when the <video> starts
                // playing and swaps its rendering; relatedTarget still points
                // inside the card in that case, so ignore it and keep hover.
                card.addEventListener("pointerleave", (event) => {
                    if (card.contains(event.relatedTarget)) return
                    this.setActive(null)
                })
                card.addEventListener("focusin", () => this.setActive(card))
                card.addEventListener("focusout", (event) => {
                    if (!card.contains(event.relatedTarget))
                        this.setActive(null)
                })
            })
        } else {
            this.onScroll = this.onScroll.bind(this)
            this.track.addEventListener("scroll", this.onScroll, {
                passive: true,
            })
            this.onScroll()
        }
    }

    disconnectedCallback() {
        if (this.onScroll)
            this.track.removeEventListener("scroll", this.onScroll)
    }

    onScroll() {
        if (this.scrollTicking) return
        this.scrollTicking = true
        requestAnimationFrame(() => {
            this.updateActiveFromScroll()
            this.scrollTicking = false
        })
    }

    updateActiveFromScroll() {
        const trackLeft = this.track.getBoundingClientRect().left
        let closest = null
        let closestDistance = Infinity

        this.realCards.forEach((card) => {
            const distance = Math.abs(
                card.getBoundingClientRect().left - trackLeft
            )
            if (distance < closestDistance) {
                closestDistance = distance
                closest = card
            }
        })

        this.setActive(closest)
    }

    setActive(card) {
        if (card === this.activeCard) return

        this.activeCard?.querySelector("video")?.pause()
        card?.querySelector("video")?.play().catch(() => {})

        this.activeCard = card
    }

    setupVideos() {
        this.cards.forEach((card) => {
            const video = card.querySelector("video")
            if (!video) return

            // video.liquid's loop:true also sets a native autoplay attribute — strip
            // it so playback is only ever driven by our own play()/pause() calls.
            video.removeAttribute("autoplay")
            video.pause()
        })
    }
}

customElements.define("social-ugc", SocialUgc)
